import React from 'react';

interface CollapsibleSectionProps {
    isOpen: boolean;
    children: React.ReactNode;
    className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ isOpen, children, className }) => {
    const sectionClass = [
        'collapsible-section',
        isOpen ? 'collapsible-section--open' : 'collapsible-section--closed',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={sectionClass}>
            {children}
        </div>
    );
};

export default CollapsibleSection;
